/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipFileApprovalAttachmentViewModel } from "../types/ScholarshipFileApprovalAttachmentViewModel.ts";
import { eFileViewerModeSchema } from "./eFileViewerModeSchema.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";

export const scholarshipFileApprovalAttachmentViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do anexo.")),
  scholarshipTypeFileId: z.optional(
    z
      .number()
      .int()
      .describe("ID do tipo de documento ao qual o anexo pertence."),
  ),
  personId: z.optional(z.number().int().describe("ID do aluno dono do anexo.")),
  url: z
    .string()
    .describe(
      "URL assinada de visualização do arquivo, válida por um dia e aberta no navegador. Nula quando o registro não possui arquivo. O caminho do blob nunca é devolvido.",
    )
    .nullish(),
  isPdf: z.optional(
    z.boolean().describe("Indica se o arquivo é PDF, conforme a extensão."),
  ),
  attachmentDate: z
    .string()
    .datetime()
    .describe(
      "Data em que o arquivo foi anexado. No legado exigia uma chamada extra. Opcional.",
    )
    .nullish(),
  approvalStatus: z.optional(
    z
      .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
      .describe(
        "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  rejectionReason: z
    .string()
    .describe(
      "Justificativa da reprova do tipo de documento. Vazia quando não há.",
    )
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o anexo está ativo.")),
  userNameCreator: z
    .string()
    .describe("Usuário que enviou o anexo. Opcional.")
    .nullish(),
  viewerMode: z.optional(
    z
      .lazy(() => eFileViewerModeSchema)
      .describe("0 = NoAttachment | 1 = Pdf | 2 = NonPdf | "),
  ),
  order: z.optional(
    z
      .number()
      .int()
      .describe("Posição cronológica do anexo na lista, iniciando em 1."),
  ),
  isDefaultSelected: z.optional(
    z
      .boolean()
      .describe(
        "Indica o anexo pré-selecionado: o mais recente do tipo de documento. Exatamente um anexo vem marcado.",
      ),
  ),
}) as unknown as ToZod<ScholarshipFileApprovalAttachmentViewModel>;
